import React, { useEffect, useState } from "react";
import banner from "../../Assets/img/banner1.jpg";

export default function PageBannerComponent(props) {
  const { title, image = "" } = props;

  const bgStyle =
    image !== undefined && image !== ""
      ? "linear-gradient(0deg, rgb(255 255 255 / 60%), rgb(255 255 255 / 60%)), url('" +
        image +
        "')"
      : "url('" + banner + "')";

  return (
   <></>
   //  <div
   //    className="page-header"
   //    style={{
   //      backgroundImage: bgStyle,
   //    }}
   //  >
   //    <div className="container">
   //      <div className="col-md-12">
   //        <h2 className="about-content">{title}</h2>
   //      </div>
   //    </div>
   //  </div>
  );
}
